import Page from '../../classes/Page'
import { app } from '../../utils/store'

import Navlist from '../../modules/Navlist'
export default class OndaZHA extends Page{
    constructor(){
        super({
            id : 'landing_onda_zha',
            element: '[data-app-page]',
            elements: { 
                designer: 'section.designer',
            }
        })
    }

    create() {
        super.create()

        console.log('onda_zahahadid')

        if(this.elements.designer){ this.createInterviews() }
    }

    createInterviews = () => {
        this.designers =  this.elements.designer.querySelectorAll('.person')

        this.designers.forEach((designer) => {
            let interview = designer.querySelector('figure video'),
                toggler = designer.querySelector('figure button')

            if(interview){
                let isPlaying = false
                toggler.onclick = (event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    toggler.style.display = 'none'

                    if(isPlaying){
                        interview.style.display = 'none'
                        interview.style.pointerEvents = 'none'
                        interview.pause()
                        isPlaying = false
                    } else {
                        interview.style.display = 'block'
                        interview.style.pointerEvents = 'all'
                        interview.play()
                        isPlaying = true
                    }
                }

                interview.addEventListener('ended', () => {
                    toggler.style.display = 'inline-flex'
                    interview.style.display = 'none'
                    interview.style.pointerEvents = 'none'
                    isPlaying = false
                })
            }
        })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}